export default __webpack_public_path__ + "static/media/rank_3.aa1a822a.svg";